import React from 'react';

const TableSkeleton = ({ rows = 5, columns = 5 }) => {
    return (
        <div className="animate-pulse">
            {[...Array(rows)].map((_, rowIndex) => (
                <div key={rowIndex} className="flex items-center space-x-4 py-4 px-4 border-b border-gray-100">
                    {[...Array(columns)].map((_, colIndex) => (
                        <div
                            key={colIndex}
                            className={`h-4 bg-gray-200 rounded ${colIndex === 0 ? 'w-1/3' : 'w-1/6'
                                }`}
                        ></div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TableSkeleton;
